import React, { Component } from 'react'

const logger = (error, info) => {
  // You can also log the error to an error reporting service
    console.log('====================================');
    console.log(error);
    console.log('====================================');
    console.log(info);
    console.log('====================================');
}

class ErrorBoundary extends Component {
    constructor(props) {
      super(props)
      this.state = { hasError: false }
    }
    componentDidCatch(error, info) {
      this.setState({ hasError: true })
      logger(error, info)
    }
  
    render() {
      if (this.state.hasError) {
        return <p>Something went wrong.</p>
      }
      return this.props.children
    }
  }
  
  export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.js